import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
export const NavLink = (props) => {
    const href = props.navigate.href;
    if (typeof href === 'string') {
        if (href.startsWith('https') || href.startsWith('www')) {
            return (_jsx("a", { href: href, title: props.navigate.description, className: props.className, children: props.children }));
        }
        return (_jsx(Link, { to: href, title: props.navigate.description, className: props.className, children: props.children }));
    }
    return (_jsx("a", { onClick: () => href(), title: props.navigate.description, className: props.className, children: props.children }));
};
//# sourceMappingURL=index.js.map